import React from 'react';
import {MY_SCORES} from "../../my-scores-widget.consts";
import {MyScoresWidgetMobilePlaceholder} from "../mobile/placeholders/my-scores-widget.mobile-placeholder";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class MyScoresWidgetPlaceholderProps extends BaseProps {
  shouldRenderHeader: Boolean = false;
  type: String;
}

export const MyScoresWidgetPlaceholder = (props: MyScoresWidgetPlaceholderProps) => {
  return (
    <React.Fragment>
      {
        props.type === MY_SCORES.TYPES.mobileDashboard && <MyScoresWidgetMobilePlaceholder {...props} />
      }
    </React.Fragment>
  )
}
